import { AreaTargetFormationFactorBase } from './base/area-target-formation-factor-base';

export class AreaTargetFormationFactor extends AreaTargetFormationFactorBase { }